import Model from '../../ModelBinding/Model';
import MissionMediaFileUploadCollection from './MissionMediaFileUploadCollection';

export default class MissionMediaFileUpload extends Model {
  public quantity?: number;
  public urls?: Array<string>;

  bind() {
    this.quantity = this.getIntAttribute('quantity');
    this.urls = this.getOriginalAttribute('urls');
  }

  static getCollection() {
    return MissionMediaFileUploadCollection;
  }
}
